import { configureStore, ConfigureStoreOptions } from '@reduxjs/toolkit'
import medicareComplaintFormReducer from 'redux/reducers/medicare-complaint-form'
import claimsReducer from 'redux/reducers/claims'
import preventiveServicesReducer from 'redux/reducers/preventive-services'
import userReducer from 'redux/reducers/users'
import authRepsReducer from 'redux/reducers/auth-reps'
import modalReducer from './reducers/modal'
import ariaLiveReducer from 'redux/reducers/aria-log'
import mspReducer from 'redux/reducers/msp'
import msaReducer from 'redux/reducers/msa'

// keeps inferred types when passed to createStore. Using Partial<ConfigureStoreOptions> doesn't infer properly
interface CreateStoreOptions {
  preloadedState?: ConfigureStoreOptions['preloadedState']
}

export const createStore = (options?: CreateStoreOptions) => {
  return configureStore({
    reducer: {
      authReps: authRepsReducer,
      claims: claimsReducer,
      preventiveServices: preventiveServicesReducer,
      msp: mspReducer,
      msa: msaReducer,
      mcf: medicareComplaintFormReducer,
      users: userReducer,
      ariaLog: ariaLiveReducer,
      modal: modalReducer
    },
    ...options
  })
}
const store = createStore()

export type ReduxStore = typeof store
export type RootState = ReturnType<typeof store.getState>
export default store
